<!--
/**
* @name: Config.vue
* @description: app广告位配置页面
* @author: 杨波
* @create: 2020/08/17 14:06:58
* @update: 2020/08/17 14:06:58
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query :hasSearchButton="false" spaceBetween>
      <y-query-item>
        <h3>{{ positionName }}配置</h3>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAddAdver">新建广告</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="dataList" :height="$root.tableHeightX" :rightFixedNumber="1" class="mt-1" :columns="initColumns()"></k-table>
  </y-view>
</template>

<script>
import {
  NESTLE_MARKETING_BACK_SERVER_ADVERT_LIST,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_ENABLED,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_DISABLED,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_DELETE,
} from "@/assets/modules/apiList";
export default {
  data() {
    return {
      isLoading: false,
      dataList: [],
      positonId: "",
      positionName: "",
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "编码",
          field: "id",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "排序",
          field: "ordinary",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "广告名称",
          field: "advertName",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "启用状态",
          field: "",
          style: {
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.isEnabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "生效时间",
          field: "",
          style: {
            width: "210px",
            textAlign: "center",
          },
          customRender: (row) => {
            const startTime = <span>{row.startTime}</span>;
            const endTime = <span>{row.endTime}</span>;
            return (
              <div>
                {" "}
                {startTime} - {endTime}
              </div>
            );
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            textAlign: "center",
          },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                删除
              </a>
            );
            return (
              <div>
                {editButton}&#12288;{deleteButton}
              </div>
            );
          },
        },
      ];
    },
    onDelete(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该广告？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MARKETING_BACK_SERVER_ADVERT_DELETE,
            para: { id: row.id },
          })
            .then((res) => {
              this.isLoading = false;
              this.getAdverList(this.positonId);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onChangeStatus(row) {
      let { id, isEnabled } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.isEnabled ? "停用" : "启用"}该广告？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: row.isEnabled ? NESTLE_MARKETING_BACK_SERVER_ADVERT_DISABLED : NESTLE_MARKETING_BACK_SERVER_ADVERT_ENABLED,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getAdverList(this.positonId);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onEdit(row) {
      const { id } = row;
      this.$controller.open({
        name: "advertiseAdd",
        query: {
          refresh: new Date() - 0,
          id,
          posId: this.positonId,
          edit: 1,
          positionName: this.positionName,
        },
        title: "编辑广告",
      });
    },
    onAddAdver() {
      const { tip } = this.$root;
      if (this.dataList.length >= 5) {
        tip("一个广告位最多只能配置5个广告");
        return;
      }
      this.$controller.open({
        name: "advertiseAdd",
        query: {
          posId: this.positonId,
          positionName: this.positionName,
          refresh: new Date() - 0,
        },
      });
    },
    getAdverList(id) {
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_ADVERT_LIST,
        para: { advertPositionId: id },
      }).then((res) => {
        this.dataList = res || [];
      });
    },
  },
  created() {
    const { id, positionName } = this.$route.query;
    this.positonId = id;
    this.positionName = positionName;
    if (id) {
      this.getAdverList(id);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.dataList = [];
    const { id, positionName } = to.query;
    this.positionName = positionName;
    this.positonId = id;
    console.log("this.positonId", this.positonId);
    if (id) {
      this.getAdverList(id);
    } else {
      if (this.positonId) {
        console.log("this.positonId", this.positonId);
        this.getAdverList(this.positonId);
      }
    }

    next();
  },
};
</script>
